import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useCompanyCompliance() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/public/companies/${slug}/compliance`).then((r) => setC(r.data)).catch(() => setMissing(true));
  }, [slug]);
  return { c, missing, slug };
}

export function CompanyShell({ c, missing, kicker, title, testid, children }) {
  if (missing) return <div className="min-h-screen bg-[#0B0F17] text-slate-300 p-10" data-testid="company-page-not-found">Company page not found.</div>;
  if (!c) return <div className="min-h-screen bg-[#0B0F17] text-slate-400 p-10">Loading…</div>;
  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100">
      <nav className="border-b border-slate-800">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <span className="font-display font-bold text-lg" data-testid="company-page-brand">{c.brand}</span>
          {c.website && <a href={c.website} className="text-sm text-slate-400 hover:text-white" rel="noreferrer">{c.website.replace(/^https?:\/\//, "")}</a>}
        </div>
      </nav>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16" data-testid={testid}>
        <p className="font-mono text-xs uppercase tracking-widest text-orange-400 mb-3">{kicker}</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mb-3">{title}</h1>
        <p className="text-slate-500 text-sm mb-10">Last updated: June 2026 · {c.legal_name}</p>
        {c.texting_status !== "active" && (
          <p className="mb-8 rounded-lg border border-sky-500/30 bg-sky-500/10 p-4 text-sm text-sky-200" data-testid="company-page-pending">
            Texting for {c.brand} is pending carrier approval. No text messages are sent under this name until approval is complete.
          </p>
        )}
        <div className="space-y-8 text-slate-300 leading-relaxed">{children}</div>
        <p className="mt-12 pt-6 border-t border-slate-800 text-xs text-slate-500">
          {c.brand} uses RoofLead software to answer missed calls and send texts. <Link to="/terms" className="underline">RoofLead Terms</Link>
        </p>
      </article>
    </div>
  );
}

export const Quote = ({ children, testid }) => (
  <blockquote data-testid={testid} className="bg-slate-900 border-l-4 border-orange-500 rounded-r-lg p-4 font-mono text-sm text-slate-100">{children}</blockquote>
);

export const contactLine = (c) => [c.support_email && `email ${c.support_email}`, c.help_phone && `call ${c.help_phone}`].filter(Boolean).join(" or ") || "reply HELP to any text";
